angular.module('sentences', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/sentences/sentences.module.js